
import { defineComponent } from 'vue';
import SearchVue from '@/components/Search.vue';
import Map from '@/components/Map.vue';

export default defineComponent({
  name: 'HomeView',
  components: {
    SearchVue,
    Map,
},
});
